import React, {useContext, useEffect, useState} from 'react';
import PictureList from 'components/pictures/list/PictureList';
import 'styles/pictures/ProfilePage.css';
import UniversalProfileHeader from 'components/universal/UniversalProfileHeader';
import {Link, useParams} from 'react-router-dom';
import {PicturesContext} from 'util/image/PictureContext';
import {UserContext} from 'components/user/UserContext';

const ProfilePage = () => {
    const [pictureMetadata, setPictureMetadata] = useState(null);
    const {user} = useContext(UserContext);
    const {userId} = useParams();

    const {sortedByLastAuthorPayment} = useContext(PicturesContext);

    useEffect(() => {
        if (!sortedByLastAuthorPayment || sortedByLastAuthorPayment.length === 0) {
            return;
        }
        const userPictures = sortedByLastAuthorPayment.filter(picture => picture.authorId === userId);
        setPictureMetadata(userPictures);
    }, [userId, sortedByLastAuthorPayment]);

    return (
        <div>
            <UniversalProfileHeader userId={userId}/>
            {pictureMetadata && pictureMetadata.length !== 0 &&
                <PictureList pictureMetadata={pictureMetadata} listType={'PROFILE'}/>
            }

            {pictureMetadata && pictureMetadata.length === 0 && (
                <div className="no-pictures">
                    No pictures to see. {' '}
                    {user && user.userId === userId && (
                        <Link to="/upload">Upload some.</Link>
                    )}
                </div>
            )}

        </div>
    );

};

export default ProfilePage;